import {Component, Input} from '@angular/core';
import {Icons} from '../../../../model/icon';
import {IconComponent} from '../../../elements/icon/icon.component';
import {TextsComponent} from "../../../elements/texts/texts.component";
import {CountryService} from '../../../../services/country-service';
import {Router} from '@angular/router';
import {RouteService} from '../../../../services/route-service';
import {findFirstContinent, findFirstCountry} from '../../../../functions/findFirstCityUrl';
import {LocationDto} from '../../../../model/continent';

@Component({
  selector: 'app-airport-panel',
    imports: [
        IconComponent,
        TextsComponent
    ],
  templateUrl: './airport-panel.component.html',
  standalone: true,
  styleUrl: './airport-panel.component.scss'
})
export class AirportPanelComponent {
  @Input() invert: boolean = false;

  constructor(protected countryService: CountryService,
              protected routeService: RouteService,
              private router: Router,) {}

  onClick() {
    const randomRoute = this.routeService.getRandom();
    const findCountry: LocationDto | undefined = findFirstCountry(randomRoute.points);
    if (findCountry === undefined) {
      return;
    }
    const country = findCountry.url
    const findContinent: LocationDto | undefined = findFirstContinent(randomRoute.points);
    if (findContinent === undefined) {
      return;
    }
    const continent = findContinent.url;
    this.router.navigate([`/destinations/${continent}/${country}/route/${randomRoute.url}`]).then(r => r);
    setTimeout(() => this.routeService.setRandom(), 10);
  }

  protected readonly Icons = Icons;
}
